export function buildSwapWithTokenSymbolsRoute(fromTokenSymbol?: string, toTokenSymbol?: string) {
  return `/swap/${fromTokenSymbol}/${toTokenSymbol}`;
}
